import type { AnyFieldApi } from "@tanstack/react-form";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils/cn";

interface NumberFieldProps {
  field: AnyFieldApi;
  label: string;
  className?: string;
}

/**
 * Integer input bound to a TanStack Form field. Stores `number | null` (empty
 * string → null) so the value maps straight onto the API's nullable
 * PositiveIntegerFields (estimated_cost, estimated_cost_hours).
 */
export function NumberField({ field, label, className }: NumberFieldProps) {
  const value = field.state.value as number | null | undefined;

  return (
    <div className={cn("space-y-1.5", className)}>
      <Label htmlFor={field.name}>{label}</Label>
      <Input
        id={field.name}
        name={field.name}
        type="number"
        min={0}
        inputMode="numeric"
        value={value == null ? "" : String(value)}
        onChange={(e) => {
          const raw = e.target.value;
          field.handleChange(raw === "" ? null : Math.max(0, Number(raw)));
        }}
        onBlur={field.handleBlur}
      />
    </div>
  );
}
